import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Form, Button, Alert } from "react-bootstrap";
import api from "../common/api"; 
import IconsBackground from "./IconsBackground";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [stage, setStage] = useState(token ? 3 : 1);
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendLink = async () => {
    if (!email) return setError("Please enter your email.");
    setLoading(true);
    setError("");
    try {
      await api.post("/forgotpassword", { email });
      setMessage("A password reset link has been sent to your email.");
      setStage(2);
    } catch (err) {
      setError("Something went wrong. Please try again or later.");
    }
    setLoading(false);
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) return setError("Please fill in all fields.");
    if (newPassword !== confirmPassword) return setError("Passwords do not match.");
    setLoading(true);
    setError("");
    try {
      await api.post("/resetpassword", { token, newPassword,confirmPassword });
      setMessage(
      "Password changed successfully! This link cannot be used again. " +
      "If needed, request a new reset link."
    );
      setStage(4);
    } catch (err) {
      setError("Invalid or expired token.");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (stage === 4) {
        const timer = setTimeout(() => {navigate("/login", { state: { fromReset: true,message: "Password changed successfully! Please log in with your new password." } }); }, 3000);
      return () => clearTimeout(timer);
    }
  }, [stage, navigate]);

  const cardStyle = {maxWidth: "550px", width: "100%",padding: "40px 30px",borderRadius: "12px", boxShadow: "0 8px 30px rgba(0,0,0,0.12)", textAlign: "center", backgroundColor: "#ffffff", zIndex: 10, };

  const buttonStyle = { backgroundColor: "#164788", border: "none",  width: "100%", height: "50px",  fontWeight: "500", color:"white"};

  const inputStyle = { height: "45px", fontSize: "15px", border: "1px solid #d1d1d1", borderRadius: "6px", padding: "6px 12px",};

  const headerStyle = { color: "#164788", marginBottom: "10px",  fontWeight: "600", fontSize: "24px",};

  const descriptionStyle = { color: "#555", fontSize: "14px", marginBottom: "25px",};


  
  return (
      
    <div style={{ minHeight: "100vh", width: "100%", position: "relative", backgroundColor: "#164788", display: "flex", justifyContent: "center", alignItems: "center",}}>
      <Card style={cardStyle}>
        {stage === 1 && (
          <>
          <span style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"15px",}}> 
            <img src="/images/Logo.png" alt="" style={{width:"80px"}} />
            <h2 style={headerStyle}>Forgot Password ?</h2>
          </span>
            <p style={descriptionStyle}>Enter your registered email to reset password</p>
            {error && <Alert variant="danger">{error}</Alert>}
            {message && <Alert variant="success">{message}</Alert>}
            <Form>
              <Form.Group className="mb-3">
                <Form.Control type="email" placeholder="Email" value={email} style={inputStyle} onChange={(e) => setEmail(e.target.value)}/>
              </Form.Group>
              <Button style={buttonStyle} onClick={handleSendLink} disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>
              <p className="mt-3" style={{ fontSize: "14px" }}> Remember your password? <a href="/login" style={{ color: "#164788" }}>Login</a></p>
            </Form>
          </>
        )}
        {stage === 2 && (
          <>
            <h2 style={headerStyle}>Check Your Email</h2>
            <p style={descriptionStyle}>
              We’ve sent a password reset link to <strong>{email}</strong>. Please check your inbox
              and click the link to reset your password.
            </p>
            {error && <Alert variant="danger">{error}</Alert>}
            <Button style={buttonStyle} onClick={()=> handleSendLink()} variant="outline-primary"> {loading ? "Sending..." : "Resend Email"} </Button>
          </>
        )}
        {stage === 3 && (
          <>
            <h2 style={headerStyle}>Reset Password</h2>
            <p style={descriptionStyle}>Enter your new password below.</p>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form>
              <Form.Group className="mb-3">
                <Form.Control type="password" placeholder="New Password" value={newPassword} style={inputStyle} onChange={(e) => setNewPassword(e.target.value)}/>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control type="password" placeholder="Confirm Password" value={confirmPassword} style={inputStyle}  onChange={(e) => setConfirmPassword(e.target.value)}/>
              </Form.Group>
              <Button style={buttonStyle} onClick={handleResetPassword} disabled={loading}> {loading ? "Updating..." : "Update Password"} </Button>
            </Form>
          </>
        )}

        {stage === 4 && (
          <>
            <h2 style={headerStyle}>Success!</h2>
            {message && <Alert variant="success">{message}</Alert>}
            <Button style={buttonStyle} onClick={() => navigate("/login")}> Redirecting To login - Go to Login </Button>
          </>
        )}
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;  
